<section class="vam_flag_section flags py-5">
  <div class="container">
    <form class="vam_flags_form" 
      [formGroup]="flagsForm"
      (submit)="saveData()">
      <div class="row">
        <div class="col-md-4 col-sm-6 mb-md-4 mb-sm-3" *ngFor="let item of flags">
          <div class="form-group"
          [class.cursor-not-allowed]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)">
            <label class="vam_checkbox_container"
              [class.untouchable]="!editableRole.includes(role) && (role === 'estimator' || role === 'qc' || role === 'purchasemanager' || disableForm)">
              <ng-container *ngIf="lang === 'en'">{{item.flag_name}}</ng-container>
              <ng-container *ngIf="lang === 'ar'">{{item.flag_name_arabic}}</ng-container>
              <input type="checkbox"
                name="{{item.short_name}}" 
                [formControlName]="item.short_name">
              <span class="vam_checkmark"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="flags__btnGrp" *ngIf="role === 'evaluator' || role === 'admin' || editableRole.includes(role)">
        <div class="row mx-n2">
          <!-- <div class="col-sm-6 px-2 mb-3 mb-sm-0">
            <button type="button" class="btn btn__tertiary w-100">{{ 'close' | translate }}</button>
          </div> -->
          <div class="col-sm-6 px-2 mx-auto" *ngIf="!disableForm || (editableRole.includes(role) && disableForm)">
            <button type="submit" class="btn btn__primary w-100">{{ 'save' | translate }}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>

<loader [active]="loaded"></loader>
